<template>
	<div class="gateway">
		<template v-if="isLoading">
			<div class="content xs-12 max3">
				Loading...
			</div>
		</template>
		<template v-else>
			<comparison-top-bar class="xs-12 fixed" :logo="clientLogo" />

			<div v-if="isUrlQueryValid && hasToken" class="content xs-12 max3">
				<div class="description">
					<h3 class="title">{{ $t("secure-payment") }}</h3>
					<p class="subtitle">{{ $t("secure-payment-one-more-step") }}</p>
				</div>

				<div class="details xs-12">
					<!-- todo: insurer logo -->
					<!-- <img src="" /> -->

					<!-- todo: product name -->
					<!-- <h2>{{ productName }}</h2> -->
					<span
						><strong>{{ $t("total") }}:</strong> {{ amount }}
						{{ currencyCode }}</span
					>
				</div>

				<payment-provider
					class="provider xs-12"
					:provider="provider"
					:watchSubmit="watchSubmitPayment"
					:paymentKey="this.clientSettings.paymentKey"
					@loading:start="isLoading = true"
					@loading:end="isLoading = false"
					@input="handlePayment($event)"
				/>

				<div class="buttons-container">
					<j-button
						:isLoading="this.isSubmitting"
						:disabled="this.isSubmitting"
						@click="handleSubmit"
					>
						{{ $t("pay-and-finish") }}
					</j-button>
				</div>

				<j-message
					:messages="messages"
					:max="1"
					:zIndex="1000"
					@click="clearMessages"
				/>
			</div>
			<template v-else-if="isUrlQueryValid">
				<strong class="error-message">
					Oops, there was an error, some parameters are not valid.
					<br />
					噢，這裡出現了錯誤，某些參數不正確
				</strong>
			</template>
			<template v-else-if="!hasToken">
				<strong class="error-message">
					Please Try again.
					<br />
					對不起，請你再下一次
				</strong>
			</template>
		</template>
	</div>
</template>

<script>
import PaymentProvider from "@/components/PaymentProvider"
import ComparisonTopBar from "@/components/ComparisonTopBar"
import JButton from "@/components/JBaseComponents/JButton"
import JMessage from "@/components/JBaseComponents/JMessage"

import { login, processTransaction } from "@covergo/covergo-sdk"

import clientSettings from "../clientSettings"
import cssVars from "css-vars-ponyfill"

/**
 * note:
 * parameters for provider/policyId & paymentAmount maybe encoded in url which we may need to decode
 * - may need insurer / productId
 */
export default {
	components: {
		ComparisonTopBar,
		PaymentProvider,
		JButton,
		JMessage
	},
	computed: {
		clientSettings() {
			return clientSettings[this.tenantId]
		},
		clientLogo() {
			return this.clientSettings && this.clientSettings.logo
				? this.clientSettings.logo
				: null
		},
		provider() {
			return this.$route.query.provider ? this.$route.query.provider : null
		},
		transactionId() {
			return this.$route.query.transactionId
				? this.$route.query.transactionId
				: null
		},
		amount() {
			return this.$route.query.amount ? this.$route.query.amount : null
		},
		hasToken() {
			return this.token
		},
		currencyCode() {
			return this.$route.query.code ? this.$route.query.code : "HKD"
		},
		tenantId() {
			return this.$route.query.tenantId ? this.$route.query.tenantId : null
		},
		clientId() {
			return this.$route.query.clientId ? this.$route.query.clientId : null
		},
		isUrlQueryValid() {
			return (
				this.$route.query.provider &&
				this.$route.query.transactionId &&
				this.$route.query.tenantId &&
				this.provider === "stripe"
			)
		}
	},
	data() {
		return {
			watchSubmitPayment: 0,
			token: null,
			messages: [],
			isLoading: false,
			isSubmitting: false
		}
	},
	methods: {
		clearMessages() {
			this.messages = []
		},

		handleSubmit() {
			this.isSubmitting = true
			this.watchSubmitPayment++
		},
		async handlePayment(payloadFromStripe) {
			const isValid = payloadFromStripe.isValid
			if (!isValid) return

			const token = payloadFromStripe.paymentToken.id

			const response = await processTransaction({
				variables: {
					transactionId: this.transactionId,
					tryIssue: false,
					input: {
						providerToken: token
					}
				},
				token: this.token,
				locale: this.$i18n.locale
			})

			const { errors, status } = response.data.processTransaction

			this.isSubmitting = false

			if (!status || status !== "success" || errors) {
				this.messages = [{ type: "error", text: errors[0] }]
				// return message
				return
			}

			// success
			this.$router.push("thanks?version=4")
			this.clearMessages()
		}
	},
	async created() {
		this.clearMessages()
		this.isLoading = true

		const response = await login({
			variables: {
				tenantId: this.tenantId,
				clientId: this.clientId || "payments",
				username: "coverQuoteGuest",
				password: "coverQuoteGuest"
			}
		})
		this.isLoading = false

		if (response.data.token_2.error || response.error) {
			return // there was an error
		}

		this.token = response.data.token_2.accessToken

		if (!this.clientSettings) return

		// sets css properties from clientSettings
		Object.entries(this.clientSettings.cssVariables).forEach(([key, value]) => {
			document.documentElement.style.setProperty(key, value)
		})

		cssVars({
			variables: this.clientSettings.cssVariables
		})
	}
}
</script>

<style scoped>
.error-message {
	padding-top: 80px;
}

.gateway {
	background-color: #f4f1ef;
	display: flex;
	justify-content: center;
	height: 100%;
	min-height: 100vh;
	width: 100%;
}

.content {
	justify-content: center;
	display: flex;
	justify-content: center;
	flex-wrap: wrap;
	height: inherit;
	padding-top: 80px;
}

.details,
.provider {
	margin-top: 24px;
	padding: 8px;
	width: 100%;
	border-radius: 4px;
	background-color: rgb(255, 255, 255);
}

.title {
	font-size: 36px;
	font-weight: 700;
	line-height: 44px;
}

.buttons-container {
	margin-top: 24px;
}

.button {
	height: 48px;
	font-size: 16px;
	text-align: center;
	background-color: rgb(217, 63, 63);
	padding: 0 20px;
	display: inline-flex;
	text-decoration-color: rgb(255, 255, 255);
	color: rgb(255, 255, 255);
	font-weight: 700;
	align-items: center;
	border-radius: 4px;
}

.button:hover {
	background-color: rgb(210, 35, 35);
	cursor: pointer;
}
</style>
